"use client";
import { Container, SectionSubHeading, SectionTitle } from "@/components";
import { fadeInUp } from "@/lib/animation/variant";
import { motion } from "framer-motion";

const CareerHeader = () => {
  return (
    <Container className="px-4 lg:px-10 flex flex-col gap-8 lg:pb-20 md:pb-16 pb-12 pt-16">
      <motion.div
        custom={0}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
      >
        <SectionTitle
          as="h1"
          title="Explore Exciting Opportunities at Octarnal"
        />
      </motion.div>
      <motion.div
        custom={1}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
      >
        <SectionSubHeading
          className="md:text-2xl text-xl"
          subtitle="We believe in fostering a dynamic and collaborative work environment that empowers our team to create digital excellence."
        />
      </motion.div>

      <motion.div
        custom={2}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
      >
        <SectionSubHeading
          className="md:text-xl text-black/70"
          subtitle="Join us on this journey of creativity, growth, and meaningful impact."
        />
      </motion.div>
    </Container>
  );
};

export default CareerHeader;
